import { ColorInput, ColorInputProps } from '@mantine/core';
import { Controller, useFormContext } from 'react-hook-form';
import { PrivateInformationFormSchemaType } from '../../hooks';

type ColorInputFieldPropsType = ColorInputProps;

export const ColorInputField: React.FC<ColorInputFieldPropsType> = ({
  ...props
}) => {
  const { control } = useFormContext<PrivateInformationFormSchemaType>();

  return (
    <Controller
      control={control}
      name="colorTourRepCalendar"
      render={({ field }) => (
        <ColorInput {...field} value={field.value ?? undefined} {...props} />
      )}
    />
  );
};
